import React from 'react'
import {Outlet} from "react-router-dom"
import NavBar from "./Nav/NavBar"
import {BreadcrumbsProvider} from "./Nav/BreadcrumbsProvider"

function NavLayout() {
    return (
        <BreadcrumbsProvider>
            <NavBar/>
            <Outlet/>
        </BreadcrumbsProvider>
    )
}

export default NavLayout